// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SendNotePage_checkbox__gD6-0","navButtons":"SendNotePage_navButtons__Ljm5L","previousMessagesContainer":"SendNotePage_previousMessagesContainer__LynhN"};